export default __webpack_public_path__ + "static/media/logo.d1420ae3.svg";